import { useEffect, useState } from "react";
import Lenis from "lenis";
import api from "@/lib/api";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import VideoShowcase from "@/components/landing/VideoShowcase";
import Services from "@/components/landing/Services";
import StormCTA from "@/components/landing/StormCTA";
import Gallery from "@/components/landing/Gallery";
import Process from "@/components/landing/Process";
import About from "@/components/landing/About";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import WhatsAppFab from "@/components/landing/WhatsAppFab";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [images, setImages] = useState([]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    api.get("/content").then((r) => {
      setContent(r.data);
      if (r.data.seo_title) document.title = r.data.seo_title;
      const desc = document.querySelector('meta[name="description"]');
      if (desc && r.data.seo_description) desc.setAttribute("content", r.data.seo_description);
    }).catch(() => setContent({}));
    api.get("/images").then((r) => setImages(r.data)).catch(() => {});
  }, []);

  if (!content) {
    return <div className="min-h-screen bg-storm" data-testid="landing-loading" />;
  }

  const marqueeItems = (content.marquee || "").split(",").map((s) => s.trim()).filter(Boolean);

  return (
    <div className="bg-storm text-foreground min-h-screen" data-testid="landing-page">
      <Navbar content={content} />
      <Hero content={content} />
      <Marquee items={marqueeItems} />
      <VideoShowcase />
      <Services services={content.services} />
      <StormCTA content={content} />
      <Gallery images={images} />
      <Process steps={content.process} />
      <About content={content} />
      <Contact content={content} />
      <Footer content={content} />
      <WhatsAppFab content={content} />
    </div>
  );
}
